import { Link, Stack } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { useAuthContext } from "@hooks/context/useAuthContext";
import { useState } from "react";
import {
  AppSnackbar,
  SnackBarMessage,
} from "@stories/molecules/AppSnackbar/AppSnackbar";
import { StyledTextField } from "@stories/atoms/StyledTextField/StyledTextField";
import { StyledLoadingButton } from "@stories/atoms/StyledButton/StyledButton";

export default function SignUp() {
  const { register, isAuthLoading } = useAuthContext();
  const [message, setMessage] = useState<SnackBarMessage | null>(null);

  const validationSchema = yup.object({
    email: yup.string().email().required("Email is required"),
  });
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setMessage(null);
      const res = await register(values.email.toLowerCase());
      if (!res.authenticated) {
        if (res.error) {
          setMessage({
            info: res.error,
            intent: "error",
          });
        } else {
          setMessage({
            info: "Something went wrong",
            intent: "error",
          });
        }
      } else {
        setMessage({
          info: "Login link sent to email",
          intent: "success",
        });
      }
    },
  });

  return (
    <>
      <Stack spacing={3}>
        <form onSubmit={formik.handleSubmit}>
          <StyledTextField
            id="email"
            name="email"
            label="Email address"
            disabled={isAuthLoading}
            fullWidth
            margin="dense"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email ? formik.errors.email : ""}
            sx={{ mb: 5 }}
          />
          <StyledLoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isAuthLoading}
            disabled={isAuthLoading}
          >
            Sign Up
          </StyledLoadingButton>
        </form>
        <Link href="/login" variant="body2">
          {"Have an account? Login"}
        </Link>
      </Stack>
      {message ? (
        <AppSnackbar
          open={!!message}
          handleClose={() => {
            setMessage(null);
          }}
          message={message}
        />
      ) : null}
    </>
  );
}
